import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import adminAccountingApi from "../services/adminAccountingApi";
import "../styles/Admin.css";

export default function AdminJournalEntryDetailPage({ adminEmail, onLogout }) {
  const { id } = useParams();
  const nav = useNavigate();
  const [status, setStatus] = useState({ type: "", msg: "" });
  const [detail, setDetail] = useState(null);

  async function load() {
    setStatus({ type: "", msg: "" });
    try {
      const res = await adminAccountingApi.getJournalEntry(id);
      if (!res?.ok) throw new Error(res?.error || "load_failed");
      setDetail(res);
    } catch {
      setStatus({ type: "error", msg: "Unable to load journal entry." });
      setDetail(null);
    }
  }

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const entry = detail?.entry;
  const lines = detail?.lines || [];

  return (
    <section className="ucx-section">
      <div className="ucx-container ucx-admin-page">
        <div className="ucx-admin-header">
          <div>
            <h1 className="ucx-admin-title">Journal Entry Detail</h1>
            <p className="ucx-admin-subtitle">Entry #{id}</p>
          </div>

          <div className="ucx-admin-header-right">
            {adminEmail && <span className="ucx-small">Signed in as {adminEmail}</span>}
            <div className="ucx-admin-header-actions">
              <button className="ucx-btn ucx-btn-outline" type="button" onClick={() => nav(-1)}>
                Back
              </button>
              {typeof onLogout === "function" ? (
                <button type="button" className="ucx-admin-btn ucx-admin-btn-reject" onClick={onLogout}>
                  Sign out
                </button>
              ) : null}
            </div>
          </div>
        </div>

      {status.type === "error" ? <div className="ucx-admin-status-error">{status.msg}</div> : null}

      {entry ? (
          <>
            <div className="ucx-admin-panel">
              <div className="ucx-admin-panel-title">Header</div>
              <div className="ucx-admin-form-grid ucx-admin-form-grid-2">
                <div className="ucx-admin-field">
                  <label>Entry No</label>
                  <input value={entry.entry_no || ""} readOnly />
                </div>
                <div className="ucx-admin-field">
                  <label>Date</label>
                  <input value={entry.entry_date || ""} readOnly />
                </div>
                <div className="ucx-admin-field">
                  <label>Source</label>
                  <input value={entry.source_module || ""} readOnly />
                </div>
                <div className="ucx-admin-field">
                  <label>Source ID</label>
                  <input value={entry.source_id || ""} readOnly />
                </div>
                <div className="ucx-admin-field" style={{ gridColumn: "1 / -1" }}>
                  <label>Memo</label>
                  <input value={entry.memo || ""} readOnly />
                </div>
              </div>
            </div>

            <div className="ucx-admin-table-wrapper">
              <table className="ucx-admin-table">
                <thead>
                  <tr>
                    <th>Account</th>
                    <th>Name</th>
                    <th>Debit</th>
                    <th>Credit</th>
                    <th>Branch</th>
                  </tr>
                </thead>
                <tbody>
                  {lines.map((l) => (
                    <tr key={l.id}>
                      <td>{l.account_code || l.account_id}</td>
                      <td>{l.account_name || "-"}</td>
                      <td>{Number(l.debit || 0).toFixed(2)}</td>
                      <td>{Number(l.credit || 0).toFixed(2)}</td>
                      <td>{l.branch_id ?? "-"}</td>
                    </tr>
                  ))}
                  {!lines.length ? (
                    <tr>
                      <td colSpan={5} className="ucx-admin-empty">
                        No lines found for this entry.
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </div>
          </>
        ) : null}
      </div>
    </section>
  );
}
